import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faCommentDots, faGlobe, faHeart, faMapMarkedAlt, faMapMarkerAlt, faPhoneAlt, faStar, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import EventApi from '../../../../Api/EventApi';
import { getApiHost, getResponseError, getUserDetailsCookie } from '../../../../Api/Utils/apiUtils';
import ErrorAlert from '../../../Form/ErrorAlert/ErrorAlert';

const SupplierExtendedDetails = ({business, prod, messageSupplier}) => {
    const hostapiurl = getApiHost()
    const [businessInfo, setbusinessInfo] = useState(null);
    const [products, setproducts] = useState(null);
    const [favoriteList, setfavoriteList] = useState(null);
    const [errormessage, seterrormessage] = useState(null);

    const customer = getUserDetailsCookie()

    useEffect(() => {
        const loadFavoriteList = async () => {
            const response = await EventApi.getFavoriteSupplierList(customer.id)
            const favoriteListApiError = getResponseError(response)
            if (favoriteListApiError) {
                seterrormessage(favoriteListApiError)
            }else{
                const listitems = response.objectVal
                setfavoriteList(listitems)
            }
        }
        loadFavoriteList()
        setbusinessInfo(business)
        setproducts(prod)
    }, [business, prod, customer.id])


    const removeFromFavoriteList = async (supplier, customer) => {
        const removetoList =  await EventApi.addOrRemovefavoriteSupplierList(customer, supplier, "d")
        const removeToListApiError = getResponseError(removetoList)
        if (!removeToListApiError) {
            window.location.reload()
        }
    }
    const addToFavoriteList = async (supplier, customer) => {
        const addtoList =  await EventApi.addOrRemovefavoriteSupplierList(customer, supplier, "i")
        const addtoListApiError = getResponseError(addtoList)
        if (!addtoListApiError) {
            window.location.reload()
        }
    }

    const isInsideList = (id) => {
        const res = favoriteList.filter(x => x.id === id).length > 0 ? true : false
        return res
    }
    

    return(
        <>
        {errormessage && 
        <ErrorAlert>{errormessage}</ErrorAlert>
        }
        {(businessInfo && favoriteList) &&
            <div className="supplier-extended-details">
                <div className="banner">
                    <h3 className="business-name">{businessInfo.businessName}</h3>
                    <div className="reating-and-hart">
                        <div className="left">
                            3.5 <FontAwesomeIcon icon={faStar} />
                        </div>
                        <div className="right">
                            {isInsideList(businessInfo.id)? 
                            <FontAwesomeIcon onClick={() => removeFromFavoriteList(businessInfo.id, customer.id)} color='#f80015' icon={faHeart} />
                            :
                            <FontAwesomeIcon onClick={() => addToFavoriteList(businessInfo.id, customer.id)} color='#EEEEEE' icon={faHeart} />
                            }
                        </div>
                    </div>
                </div>
                
                <div className="contact">
                    {businessInfo.mobileNumber &&
                    <div className="call">
                        <a href={`tel:${businessInfo.mobileNumber}`}>
                            <FontAwesomeIcon icon={faPhoneAlt} />
                            <p>Call</p>
                        </a>
                    </div>}
                    {(businessInfo.businessLatitude && businessInfo.businessLongitude) &&
                    <div className="direction">
                        <a target="_blank" rel="noreferrer" href={`https://www.google.com/maps/@${businessInfo.businessLatitude},${businessInfo.businessLongitude},15z`}>
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                            <p>Directions</p>
                        </a>
                    </div>}
                    <div className="message" onClick={() => messageSupplier(business)}>
                        <FontAwesomeIcon icon={faCommentDots} />
                        <p>Message</p>
                    </div>
                </div>
                <hr />
                <div className="identification">
                    {(businessInfo.firstName && businessInfo.lastName) &&
                    <div>
                        <FontAwesomeIcon icon={faUser} />
                        <p>{`${businessInfo.firstName} ${businessInfo.lastName}`}</p>
                    </div>}
                    {businessInfo.mobileNumber &&
                    <div>
                        <FontAwesomeIcon icon={faPhoneAlt} />
                        <p>{businessInfo.mobileNumber}</p>
                    </div>}
                    {businessInfo.businessAddress &&
                    <div>
                        <FontAwesomeIcon icon={faMapMarkedAlt} />
                        <p>{businessInfo.businessAddress}</p>
                    </div>}
                    {businessInfo.webSiteUrl && 
                    <div>
                        <FontAwesomeIcon icon={faGlobe} />
                        <p><a target="_blank" rel="noreferrer" href={businessInfo.webSiteUrl}>{businessInfo.webSiteUrl}</a></p>
                    </div>}
                    {businessInfo.facebookLink &&
                    <div>
                        <FontAwesomeIcon icon={faFacebook} />
                        <p><a target="_blank" rel="noreferrer" href={businessInfo.facebookLink}>{businessInfo.facebookLink}</a></p>
                    </div>}
                    {businessInfo.InstagramLink &&
                    <div>
                        <FontAwesomeIcon icon={faInstagram} />
                        <p><a target="_blank" rel="noreferrer" href={businessInfo.InstagramLink}>{businessInfo.InstagramLink}</a></p>
                    </div>}
                </div>
                <hr />
                {products && products.length > 0 &&
                <div className="products">
                    <div className="heading">
                        <h4>Products</h4>
                    </div>
                    <div className="items">
                        {products.map((product) => (
                            <Link key={`${product.id}`} to={`/suppliers/${businessInfo.userId}/${product.id}`}>
                            <div className="each-product">
                                {product.GetproductInfoImage && product.GetproductInfoImage.length > 0 ?
                                <div className="prouct-img">
                                    <img src={`${hostapiurl}/${product.GetproductInfoImage[0].imageUrl}`} alt="product" />
                                </div>
                                :
                                <div className="prouct-img">
                                    <img src="/img/no_image.jpg" alt="product" />
                                </div>
                                }
                                <div className="content">
                                    <h4>{product.title && product.title}</h4>
                                    {product.price &&<h5>${product.price}</h5>}
                                </div>
                            </div>
                            </Link>
                        ))}

                    </div>
                </div>}
            </div>}
        </>
    );
};

export default SupplierExtendedDetails;
